(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"ffa669f662b686a03e2b943fbb1a9afa7dab7563-rg"};


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 1019
// module chunks = 0